import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, Grid, MenuItem, Select, Tab, Tabs, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./_rmlPopup.scss";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import moment from "moment";
import exifr from "exifr";
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import { Base64 } from "js-base64";
import { generateVideoThumbnails } from "@rajesh896/video-thumbnails-generator";
import axios from "axios";
import toast from "react-hot-toast";
import CheckIcon from "@mui/icons-material/Check";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import FilterListIcon from "@mui/icons-material/FilterList";
import { v4 as uuidv4 } from "uuid";
import { GetUTCTime } from "../../Helpers/GetUTCTime";
import Compressor from "compressorjs";
import {
  UpdateReduxLocal,
  bulkUploadMediaLength,
  failBulkUploadMediaLength,
  failedBulkUploadMedia,
  getInspectionData,
  getInspectionDataWithOutLoader,
  isbulkUploading,
  successfulBulkUploadMediaLength,
} from "../../Redux/Actions/CommonActions";
import {getImageDimensions, resizeImage } from "../../Helpers/HelperFunctions";
import { apiCallintroductoryTextMedia, apiCallDeleteIntroductoryTextMedia, UpdateTemplateDataSpecific } from "../../Helpers/ApiCall";
import DeleteRMLMedia, { isRecordDeleted, isSameRmlMedia } from "../LineDetails/CommentDetails/DeleteRMLMedia";
import { origin } from "../../Config/Api-constants";
import DeleteConfirmationDialog from "../../Common/Alert/DeleteConfirmationDialog";
import RMLPopupAllMedia from "../../Pages/ReportLibrary/RMLPopupAllMedia";
import RMLPopupImage from "../../Pages/ReportLibrary/RMLPopupImage";
import RMLPopupVideo from "../../Pages/ReportLibrary/RMLPopupVideo";

const sortFilters = [
  {
    value: "All",
    label: "All",
  },
  {
    value: "Used",
    label: "Used",
  },
  {
    value: "Unused",
    label: "Unused",
  },
];

const filters = [
  {
    value: "Most used",
    label: "Most used",
  },
  {
    value: "Newest",
    label: "Newest",
  },
  {
    value: "Oldest",
    label: "Oldest",
  },
  {
    value: "File name",
    label: "File name",
  },
];

const theme = createTheme({
  typography: {
    body1: {
      fontSize: "12px",
    },
  },
  customMenuItem: {
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
    "&.Mui-selected": {
      backgroundColor: "#e0e0e0",
    },
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
let cancelBulkUploading = false;

const getSafeCreatedAt = (metadata) => {
  const now = moment.utc();
  let parsed = null;
  if (metadata != null && typeof metadata === "object" && !(metadata instanceof Date) && !moment.isMoment(metadata)) {
    const raw = metadata.DateTimeOriginal;
    parsed = raw ? moment.utc(raw) : null;
  } else if (metadata != null && metadata !== "") {
    parsed = moment.utc(metadata);
  }
  if (!parsed || !parsed.isValid()) return now.format("YYYY-MM-DD HH:mm:ss");
  if (parsed.isAfter(now)) return now.format("YYYY-MM-DD HH:mm:ss");
  return parsed.format("YYYY-MM-DD HH:mm:ss");
};

const RMLpopup = ({ showRMLpopup, setShowRMLpopup, templateId, categoryId }) => {
  const handleCloseRMLpopup = () => setShowRMLpopup(false);
  const [activeTab, setActiveTab] = useState(0);
  const [filterValue, setFilterValue] = useState("All");
  const [selected, setSelected] = React.useState("Newest");
  const [image, setImage] = useState("");
  const [mediaList, setMediaList] = useState([]);
  const [failedMediaList, setFailedMediaList] = useState([]);
  const [hoveredDeletedMediaUuid, setHoveredDeletedMediaUuid] = useState("");
  const [openDeleteMediaModal, setOpenDeleteMediaModal] = useState(false);
  const [warningModal, setWarningModal] = useState(false);

  const [deleteMedia, setDeleteMedia] = useState("");
  const [selectedMedia, setSelectedMedia] = useState([]);
  const storeData = useSelector((state) => state.CommonReducer);
  const [allMediaList, setAllMediaList] = useState([]);
  const location = useLocation();
  const isReportMediaLibrary = location.pathname === "/report_media_library";
  const templateMediaString = "template-editor/";
  let fileInput = useRef(null);
  const dispatch = useDispatch();
  let responseCount = 0;
  let videoUploadCount = 0;
  let imageUploadCount = 0;
  let successCount = 0;
  let errorCount = 0;
  let sizeErrorCount = 0;
  let failedBulkUpload = [];
  let UploadedDuplicateMedia = storeData?.inspectionDataForBulkMedia?.data?.report_media_library_files || [];

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleBulkUploadingWarningPopup = () => {
    setWarningModal(true);
  };
  const handleCloseWarningPopup = () => {
    setWarningModal(false);
  };

  const handleErrorDoneButton = () => {
    dispatch(isbulkUploading(false));
    dispatch(failBulkUploadMediaLength(0));
    dispatch(bulkUploadMediaLength(0));
    dispatch(failedBulkUploadMedia([]));
    callInitiateAPI();
    let reportData = storeData?.inspectionDataForBulkMedia;
    reportData.data.report_media_library_files = UploadedDuplicateMedia?.filter((object) => object?.online_url != null);
    dispatch(UpdateReduxLocal(reportData));
  };
  const handleCancelBulkUploadErrorModal = () => {
    dispatch(bulkUploadMediaLength(0));
    dispatch(successfulBulkUploadMediaLength(0));
    callInitiateAPI();
  };

  const handleFilterChange = (e) => {
    setFilterValue(e?.target?.value);
  };
  const handleTimeFilterChange = (e) => {
    setSelected(e?.target?.value);
  };

  const handleCancelBulkUploadMedia = () => {
    cancelBulkUploading = true;
    dispatch(bulkUploadMediaLength(0));
    dispatch(isbulkUploading(false));
  };

  const handleMediaClick = (index, media) => {
    const selectedIndex = selectedMedia.indexOf(index);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedMedia, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedMedia.slice(1));
    } else if (selectedIndex === selectedMedia.length - 1) {
      newSelected = newSelected.concat(selectedMedia.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selectedMedia.slice(0, selectedIndex));
      newSelected = newSelected.concat(selectedMedia.slice(selectedIndex + 1));
    }
    setSelectedMedia(newSelected);
  };
  const filteredMediaList = mediaList?.filter((_, index) => selectedMedia?.includes(index));
  const isSelected = (index) => selectedMedia?.indexOf(index) !== -1;

  const buildSelectedMediaPayload = async (filteredMediaList) => {
    return Promise.all(
      filteredMediaList.map(async (media) => {
        return {
          id: media?.id || null,
          url: media?.url || null,
          name: media?.name || null,
          type: media?.type || null,
          uuid: media?.uuid || null,
          edited: false,
          newUrl: media?.newUrl || null,
          online: media?.online || "online",
          filetype: media?.media_type?.startsWith("image/") || media?.type?.startsWith("image/") ? "image" : "video",
          localUrl: media?.localUrl || null,
          OriginUrl: media?.OriginUrl || null,
          editCount: 0,
          onlineUrl: media?.onlineUrl || media?.online_url || null,
          orginName: media?.orginName || null,
          thumbnail: media?.thumbnail || media?.thumbnail_url,
          created_at: media?.created_at || null,
          is_deleted: media?.is_deleted || 0,
          updated_at: await GetUTCTime(),
          description: media?.description || null,
          OriginlocalUrl: media?.OriginlocalUrl || null,
          OriginThumbnail: media?.OriginThumbnail || null,
          isOriginUploaded: media?.isOriginUploaded || false,
          uploaded_by: media?.uploaded_by,
          is_deleted_from_rml: media?.is_deleted_from_rml || 0,
          inspection_guid: media?.inspection_guid || null,
          isUserMade: media?.isUserMade !== undefined ? media.isUserMade : true,
          is_report_media_library_file: media?.is_report_media_library_file !== undefined ? media.is_report_media_library_file : true,
          times_used: media?.times_used || 0,
        };
      })
    );
  };

  // The API keeps one record per uuid within a category. A decorated copy shares its original's uuid, so adding the
  // original (or the copy) to a category that already holds the other would overwrite it. Give the new usage its own uuid.
  const assignUniqueUuidInCategory = (selectedMediaPayload) => {
    const existingCategoryMedia =
      storeData?.inspectionData?.data?.inspectiontemplates
        ?.find((template) => String(template?.template_id) === String(templateId))
        ?.categories?.find((category) => String(category?.id) === String(categoryId))
        ?.introductory_text_media?.filter((media) => media?.is_deleted !== 1) ?? [];
    return selectedMediaPayload.map((media) => {
      const isDifferentImageWithSameUuid = existingCategoryMedia.some(
        (existingMedia) => existingMedia?.uuid === media?.uuid && (existingMedia?.onlineUrl ?? existingMedia?.url) !== media?.onlineUrl
      );
      return isDifferentImageWithSameUuid ? { ...media, uuid: uuidv4() } : media;
    });
  };

  const handleUploadIntroTextMedia = async () => {
    const updatedSelectedMedia = assignUniqueUuidInCategory(await buildSelectedMediaPayload(filteredMediaList));
    const formData = {
      template_id: templateId,
      category_id: categoryId,
      inspection_id: storeData?.inspectionData?.data?.inspection_id,
      guid: storeData?.inspectionData?.data?.guid,
      introductory_text_media: updatedSelectedMedia,
    };
    apiCallintroductoryTextMedia(dispatch, formData);
    // setTimeout(() => {
    //   const sessionAssociateCompanyKey = Base64.decode(sessionStorage.getItem("AC"));
    //   const guid = sessionStorage.getItem("guid");
    //   const sessionUserId = Base64.decode(sessionStorage.getItem("UI"));

    //   dispatch(
    //     getInspectionData({
    //       guid,
    //       associate_company: sessionAssociateCompanyKey,
    //       user_id: sessionUserId,
    //     })
    //   );
    // }, 2000);
    setShowRMLpopup(false);
  };

  async function convertBase64ToFile(base64String, filename, file, formData, fileType, currentMediaLength, orderVal, e, type, UploadedDuplicateMedia, failedBulkUpload, metadata) {
    const arr = base64String[0].split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    let uploadfile;
    if (type == "drag") {
      uploadfile = e;
    } else {
      uploadfile = e.target.files;
    }
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    let thumbVideoFile = new File([u8arr], filename, { type: mime });
    let thumbFile;
    const { imgWidth, imgHeight } = await getImageDimensions(thumbVideoFile);
    const maxWidth = 320;
    const maxHeight = 320;
    const quality = 1;
    let newWidth, newHeight;

    if (imgWidth > imgHeight) {
      // Landscape orientation
      newHeight = maxHeight;
      newWidth = (maxHeight / imgHeight) * imgWidth;
    } else {
      // Portrait orientation
      newWidth = maxWidth;
      newHeight = (maxWidth / imgWidth) * imgHeight;
    }
    let thumbnailImage = await resizeImage(thumbVideoFile, newWidth, newHeight, quality);
    thumbFile = new File([thumbnailImage], `${thumbnailImage.name}`, { type: "image/jpeg" });
    let params = {};
    params = {
      fileToUpload: file,
      inspectionGuid: sessionStorage.getItem("guid"),
      created_at: getSafeCreatedAt(metadata),
      uploaded_by: parseInt(sessionStorage.getItem("UID")),
      thumbnail: thumbFile,
      fileGuid: file?.uuid,
    };
    Object.keys(params).forEach((key) => formData.append(key, params[key]));

    // sync API call
    let baseUrl = await origin();
    let sessionAPIKey = sessionStorage.getItem("CK");
    let sessionSecretKey = sessionStorage.getItem("SK");
    try {
      const response = await axios.post(`${baseUrl}media-lib-file-upload`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
          "api-key": `${Base64.decode(sessionAPIKey)}`,
          "platform": 'web',
          "api-platform": 'WRW',
          "user_id": sessionStorage.getItem('UID'),
          "product": sessionStorage.getItem('asoCom'),
          "mode": 'online',
        },
      });
      const result = response.data;
      const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
      if (mediaIndex !== -1) {
        UploadedDuplicateMedia[mediaIndex].online_url = result?.data?.onlineUrl;
        UploadedDuplicateMedia[mediaIndex].thumbnail_url = result?.data?.thumbnail;
        UploadedDuplicateMedia[mediaIndex].name = file?.name;
      }
      let reportData = storeData?.inspectionDataForBulkMedia;
      reportData.data.report_media_library_files = UploadedDuplicateMedia;
      dispatch(UpdateReduxLocal(reportData));
      responseCount++;
      videoUploadCount++;
      successCount++;
      dispatch(successfulBulkUploadMediaLength(successCount));
    } catch (error) {
      setFailedMediaList((prev) => [...prev, file]);
      failedBulkUpload.push(file);
      dispatch(failedBulkUploadMedia(failedBulkUpload));
      const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
      if (mediaIndex !== -1) {
        UploadedDuplicateMedia[mediaIndex].is_media_uploading = false;
      }
      let reportData = storeData?.inspectionDataForBulkMedia;
      reportData.data.report_media_library_files = UploadedDuplicateMedia;
      dispatch(UpdateReduxLocal(reportData));
      responseCount++;
      videoUploadCount++;
      errorCount++;
      toast.error(error?.message);
    }
    if (responseCount === uploadfile?.length) {
      responseCount = 0;
      videoUploadCount = 0;
      imageUploadCount = 0;
      errorCount = 0;
      sizeErrorCount = 0;
      successCount = 0;
    }
    dispatch(isbulkUploading(false));
  }

  async function compressImage(file) {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        success(result) {
          resolve(result);
        },
        error(err) {
          reject(err);
        },
      });
    });
  }

  const handleAddMedia = async (e, type) => {
    dispatch(successfulBulkUploadMediaLength(0));
    dispatch(failBulkUploadMediaLength(0));
    dispatch(bulkUploadMediaLength(0));
    let currentMediaLength = 0;
    let uploadfile;
    let metadata;
    if (type == "retry") {
      uploadfile = e;
    } else uploadfile = e?.target?.files;
    dispatch(bulkUploadMediaLength(uploadfile?.length));
    setImage(uploadfile);
    for (let i = 1; i <= uploadfile.length; i++) {
      dispatch(isbulkUploading(true));
      if (cancelBulkUploading) {
        cancelBulkUploading = false;
        dispatch(isbulkUploading(false));
        callInitiateAPI();
        return;
      }
      let file = uploadfile[i - 1];
      if (type != "retry") {
        let uuid = uuidv4();
        uploadfile[i - 1].uuid = uuid;
        UploadedDuplicateMedia.push({
          name: file?.name,
          inspection_guid: sessionStorage.getItem("guid"),
          is_report_media_library_file: true,
          media_type: file?.type,
          online_url: null,
          thumbnail_url: null,
          uploaded_by: parseInt(sessionStorage.getItem("UID")),
          times_used: 0,
          uuid: uuid,
          id: uuid,
          created_at: await GetUTCTime(),
          updated_at: await GetUTCTime(),
          is_media_uploading: true,
        });
      } else {
        let mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
        if (mediaIndex !== -1) {
          UploadedDuplicateMedia[mediaIndex].is_media_uploading = true;
        }
      }
      let formData = new FormData();
      const fileSize = file.size;
      const sizeInMB = Math.round(fileSize / (1024 * 1024));
    }
    let reportData = storeData?.inspectionDataForBulkMedia;
    reportData.data.report_media_library_files = UploadedDuplicateMedia;
    dispatch(UpdateReduxLocal(reportData));
    for (let i = 1; i <= uploadfile.length; i++) {
      dispatch(isbulkUploading(true));
      if (cancelBulkUploading) {
        cancelBulkUploading = false;
        dispatch(isbulkUploading(false));
        callInitiateAPI();
        return;
      }
      let formData = new FormData();
      let file = uploadfile[i - 1];
      let fileType = null;
      if ((file?.type === "image/jpeg" && !file?.name.toLowerCase().endsWith(".jfif")) || file?.type === "image/png" || file?.type === "image/jpg") {
        fileType = "image";
      } else if (file?.type == "video/mov" || file?.type == "video/mp4" || file?.type == "video/quicktime") {
        fileType = "video";
      } else {
        fileType = "unsupported";
      }
      if (fileType === "image") {
        try {
          metadata = await exifr.parse(file);
        } catch (error) {
          metadata = null;
        }
      }
      if (fileType === "video") {
        metadata = file?.lastModifiedDate;
      }
      const fileSize = file.size;
      const sizeInMB = Math.round(fileSize / (1024 * 1024));
      if (sizeInMB >= 1024) {
        toast.error("File size too Big, please select a file less than 1024 MB");
        errorCount++;
        responseCount++;
        sizeErrorCount++;
        if (responseCount === uploadfile.length) {
          if (successCount > 0) {
            dispatch(successfulBulkUploadMediaLength(successCount));
          }
          if (errorCount > 0) {
            dispatch(failBulkUploadMediaLength(errorCount));
          }
          responseCount = 0;
          videoUploadCount = 0;
          imageUploadCount = 0;
          errorCount = 0;
          sizeErrorCount = 0;
          successCount = 0;
        }
      } else if (!file.type.match(/(image\/(png|jpg|jpeg))|(video\/(mp4|mov|quicktime))/)) {
        const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
        if (mediaIndex !== -1) {
          UploadedDuplicateMedia[mediaIndex].is_media_uploading = false;
        }
        let reportData = storeData?.inspectionDataForBulkMedia;
        reportData.data.report_media_library_files = UploadedDuplicateMedia;
        dispatch(UpdateReduxLocal(reportData));
        errorCount++;
        responseCount++;
        if (responseCount === uploadfile.length) {
          if (successCount > 0) {
            dispatch(successfulBulkUploadMediaLength(successCount));
          }
          if (errorCount > 0) {
            dispatch(failBulkUploadMediaLength(errorCount));
          }
          responseCount = 0;
          videoUploadCount = 0;
          imageUploadCount = 0;
          errorCount = 0;
          sizeErrorCount = 0;
          successCount = 0;
        }
      } else {
        if (fileType === "image") {
          let compressedFile;
          let thumbImage;
          const { imgWidth, imgHeight } = await getImageDimensions(file);
          const maxWidth = 320;
          const maxHeight = 320;
          const quality = 0.8;
          let newWidth, newHeight;
          if (imgWidth > imgHeight) {
            // Landscape orientation
            newHeight = maxHeight;
            newWidth = (maxHeight / imgHeight) * imgWidth;
          } else {
            // Portrait orientation
            newWidth = maxWidth;
            newHeight = (maxWidth / imgWidth) * imgHeight;
          }
          let thumbnailImage = await resizeImage(file, newWidth, newHeight, quality);
          thumbImage = new File([thumbnailImage], `${thumbnailImage.name}`, { type: "image/jpeg" });
          if (file?.size > 512000) {
            // =======
            try {
              const compressedFilee = await compressImage(file);
              compressedFile = new File([compressedFilee], `${compressedFilee.name}`, { type: "image/jpeg" });
              let params = {};
              params = {
                fileToUpload: compressedFile,
                inspectionGuid: sessionStorage.getItem("guid"),
                created_at: getSafeCreatedAt(metadata),
                thumbnail: thumbImage,
                uploaded_by: parseInt(sessionStorage.getItem("UID")),
                fileGuid: file?.uuid,
              };
              Object.keys(params).forEach((key) => formData.append(key, params[key]));
              // sync API call
              let baseUrl = await origin();
              let sessionAPIKey = sessionStorage.getItem("CK");
              let sessionSecretKey = sessionStorage.getItem("SK");
              try {
                const response = await axios.post(`${baseUrl}media-lib-file-upload`, formData, {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
                    "api-key": `${Base64.decode(sessionAPIKey)}`,
                    "platform": 'web',
                    "api-platform": 'WRW',
                    "user_id": sessionStorage.getItem('UID'),
                    "product": sessionStorage.getItem('asoCom'),
                    "mode": 'online',
                  },
                });
                const result = response.data;
                const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
                if (mediaIndex !== -1) {
                  UploadedDuplicateMedia[mediaIndex].online_url = result?.data?.onlineUrl;
                  UploadedDuplicateMedia[mediaIndex].thumbnail_url = result?.data?.thumbnail;
                  UploadedDuplicateMedia[mediaIndex].name = file?.name;
                }
                let reportData = storeData?.inspectionDataForBulkMedia;
                reportData.data.report_media_library_files = UploadedDuplicateMedia;
                dispatch(UpdateReduxLocal(reportData));
                responseCount++;
                imageUploadCount++;
                successCount++;
                dispatch(successfulBulkUploadMediaLength(successCount));
              } catch (error) {
                setFailedMediaList((prev) => [...prev, file]);
                failedBulkUpload.push(file);
                dispatch(failedBulkUploadMedia(failedBulkUpload));
                const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
                if (mediaIndex !== -1) {
                  UploadedDuplicateMedia[mediaIndex].is_media_uploading = false;
                }
                let reportData = storeData?.inspectionDataForBulkMedia;
                reportData.data.report_media_library_files = UploadedDuplicateMedia;
                dispatch(UpdateReduxLocal(reportData));
                toast.error(error?.message);
                responseCount++;
                errorCount++;
                imageUploadCount++;
              }
              if (responseCount === uploadfile.length) {
                if (successCount > 0) {
                  dispatch(successfulBulkUploadMediaLength(successCount));
                }
                if (errorCount > 0) {
                  dispatch(failBulkUploadMediaLength(errorCount));
                }
                responseCount = 0;
                videoUploadCount = 0;
                imageUploadCount = 0;
                errorCount = 0;
                sizeErrorCount = 0;
                successCount = 0;
              }
            } catch (error) {
              console.error("Error compressing image:", error);
            }
          } else {
            compressedFile = file;
            let params = {};
            params = {
              fileToUpload: compressedFile,
              thumbnail: thumbImage,
              uploaded_by: parseInt(sessionStorage.getItem("UID")),
              inspectionGuid: sessionStorage.getItem("guid"),
              created_at: getSafeCreatedAt(metadata),
              fileGuid: file?.uuid,
            };
            Object.keys(params).forEach((key) => formData.append(key, params[key]));
            // sync API call
            let baseUrl = await origin();
            let sessionAPIKey = sessionStorage.getItem("CK");
            let sessionSecretKey = sessionStorage.getItem("SK");
            try {
              const response = await axios.post(`${baseUrl}media-lib-file-upload`, formData, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  Authorization: `Bearer ${Base64.decode(sessionSecretKey)}`,
                  "api-key": `${Base64.decode(sessionAPIKey)}`,
                  "platform": 'web',
                  "api-platform": 'WRW',
                  "user_id": sessionStorage.getItem('UID'),
                  "product": sessionStorage.getItem('asoCom'),
                  "mode": 'online',
                },
              });
              const result = response.data;
              const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
              if (mediaIndex !== -1) {
                UploadedDuplicateMedia[mediaIndex].online_url = result?.data?.onlineUrl;
                UploadedDuplicateMedia[mediaIndex].thumbnail_url = result?.data?.thumbnail;
                UploadedDuplicateMedia[mediaIndex].name = file?.name;
              }
              let reportData = storeData?.inspectionDataForBulkMedia;
              reportData.data.report_media_library_files = UploadedDuplicateMedia;
              dispatch(UpdateReduxLocal(reportData));
              responseCount++;
              imageUploadCount++;
              successCount++;
              dispatch(successfulBulkUploadMediaLength(successCount));
            } catch (error) {
              setFailedMediaList((prev) => [...prev, file]);
              failedBulkUpload.push(file);
              dispatch(failedBulkUploadMedia(failedBulkUpload));
              const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
              if (mediaIndex !== -1) {
                UploadedDuplicateMedia[mediaIndex].is_media_uploading = false;
              }
              let reportData = storeData?.inspectionDataForBulkMedia;
              reportData.data.report_media_library_files = UploadedDuplicateMedia;
              dispatch(UpdateReduxLocal(reportData));
              responseCount++;
              errorCount++;
              imageUploadCount++;
              toast.error(error?.message);
            }
            if (responseCount === uploadfile.length) {
              if (successCount > 0) {
                dispatch(successfulBulkUploadMediaLength(successCount));
              }
              if (errorCount > 0) {
                dispatch(failBulkUploadMediaLength(errorCount));
              }
              responseCount = 0;
              videoUploadCount = 0;
              imageUploadCount = 0;
              errorCount = 0;
              sizeErrorCount = 0;
              successCount = 0;
            }
          }
        } else if (fileType === "video") {
          await generateVideoThumbnails(file, 10).then(async (thumbs) => {
            await convertBase64ToFile(thumbs, "name", file, formData, fileType, currentMediaLength, i, e, type, UploadedDuplicateMedia, failedBulkUpload, metadata);
          });
        } else {
          errorCount++;
          const mediaIndex = UploadedDuplicateMedia?.findIndex((item) => item?.uuid === file?.uuid);
          if (mediaIndex !== -1) {
            UploadedDuplicateMedia[mediaIndex].is_media_uploading = false;
          }
          let reportData = storeData?.inspectionDataForBulkMedia;
          reportData.data.report_media_library_files = UploadedDuplicateMedia;
          dispatch(UpdateReduxLocal(reportData));
          dispatch(isbulkUploading(false));
          dispatch(failBulkUploadMediaLength(errorCount));
        }
      }
    }
    dispatch(isbulkUploading(false));
  };

  const handleRetryFailMedia = () => {
    handleAddMedia(storeData?.failedBulkUploadMedia, "retry");
  };

  const callInitiateAPI = async () => {
    // let sessionAssociateCompanyKey = Base64.decode(sessionStorage.getItem("AC"));
    // let guid = sessionStorage.getItem("guid");
    // let sessionUserId = Base64.decode(sessionStorage.getItem("UI"));
    // dispatch(getInspectionDataWithOutLoader({ guid: guid, associate_company: sessionAssociateCompanyKey, user_id: sessionUserId }));
    dispatch(isbulkUploading(false));
    dispatch(successfulBulkUploadMediaLength(0));
    dispatch(failBulkUploadMediaLength(0));
    dispatch(bulkUploadMediaLength(0));
    dispatch(failedBulkUploadMedia([]));
  };

  useEffect(() => {
    {
      showRMLpopup &&
        setTimeout(() => {
          if (storeData?.bulkUploadMediaLength > 0 && storeData?.successfulBulkUploadMediaLength > 0 && storeData?.bulkUploadMediaLength == storeData?.successfulBulkUploadMediaLength) {
            handleCancelBulkUploadErrorModal();
          }
        }, 1000);
    }
  }, [storeData?.isbulkUploading]);

  function mergeObjectsByCategoryId(data) {
    const mergedObjects = {};
    data?.forEach((item) => {
      if (item) {
        [item].forEach((innerItem) => {
          const categoryId = innerItem.category_id;
          if (!mergedObjects[categoryId]) {
            mergedObjects[categoryId] = { ...innerItem };
          } else {
            mergedObjects[categoryId].value = mergedObjects[categoryId]?.value?.concat(innerItem.value);
          }
        });
      }
    });
    return Object.values(mergedObjects);
  }

  useEffect(() => {
    let media = [];
    storeData?.inspectionDataForBulkMedia?.data?.report_media_library_files?.forEach((item) => {
      // Template media never belongs in the report media library.
      if (item?.online_url?.startsWith(templateMediaString) || item?.thumbnail_url?.startsWith(templateMediaString)) {
        return;
      }
      media.push({ ...item, onlineUrl: item?.online_url, thumbnail: item?.thumbnail_url, type: item?.media_type, edited: false });
    });
    storeData?.inspectionDataForBulkMedia?.data?.inspectiontemplates?.forEach((template) => {
      if (template.is_pdf_template !== 1) {
        template?.categories?.forEach((category) => {
          category?.introductory_text_media?.forEach((image) => {
            if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
              return;
            }
            let times_used = 1;
            if (category?.is_deleted === 1 || image?.is_deleted === 1) {
              times_used = 0;
            }
            if (image?.is_report_media_library_file) {
              media?.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
            } else {
              media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
            }
          });
          category?.lines?.forEach((line) => {
            line?.line_input_controls !== null &&
              line?.line_input_controls !== undefined &&
              line?.line_input_controls.length !== 0 &&
              line?.line_input_controls
                ?.filter((data) => data.type === "Media")
                ?.forEach((MediaData) => {
                  MediaData?.data?.forEach((image) => {
                    if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                      return;
                    }
                    let times_used = 1;
                    if (category?.is_deleted === 1 || line?.is_deleted === 1 || image?.is_deleted === 1) {
                      times_used = 0;
                    }
                    if (image?.is_report_media_library_file) {
                      media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                    } else {
                      media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                    }
                  });
                });
            line?.line_input_controls?.filter((data) => data?.type == "Nameplate")?.[0]?.data?.image &&
              media.push(line?.line_input_controls?.filter((data) => data?.type == "Nameplate")?.[0]?.data?.image);
            line?.comments?.length !== 0 &&
              line?.comments?.forEach((comment) =>
                comment?.comment_input_controls
                  ?.filter((data) => data.type === "Media")
                  ?.forEach((innerData) => {
                    innerData?.data?.forEach((image) => {
                      if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                        return;
                      }
                      let times_used = 1;
                      // Deleting a comment only soft-deletes the comment, not its media, so check the owners too
                      if (category?.is_deleted === 1 || line?.is_deleted === 1 || comment?.is_deleted === 1 || image?.is_deleted === 1) {
                        times_used = 0;
                      }
                      if (image?.is_report_media_library_file) {
                        media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                      } else {
                        media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                      }
                    });
                  })
              );
          });
        });
      } else {
        {
          mergeObjectsByCategoryId(
            template?.pdf_data?.filter((category) => {
              return category?.type === "MediaUploader" && category;
            })
          )?.forEach((item) => {
            if (item.value.length !== 0) {
              item.value?.forEach((image) => {
                if (image?.onlineUrl?.startsWith(templateMediaString) || image?.thumbnail?.startsWith(templateMediaString)) {
                  return;
                }
                let times_used = 1;
                if (image?.is_deleted === 1) {
                  times_used = 0;
                }
                if (image?.is_report_media_library_file) {
                  media.push({ ...image, onlineUrl: image?.online_url, thumbnail: image?.thumbnail_url, type: image?.media_type, times_used: times_used });
                } else {
                  media?.push({ ...image, online_url: image?.onlineUrl, thumbnail_url: image?.thumbnail, media_type: image?.type, times_used: times_used, template_media: true });
                }
              });
            } else return null;
          });
        }
      }
    });
    let uniqueMedia = [];
    let mediaWithOriginal = [];
    media.forEach((mediaItem) => {
      const mediaDeletedFromRML = mediaItem?.is_deleted_from_rml || 0;
      const mediaIndex = mediaWithOriginal.findIndex((itm) => {
        return mediaItem.uuid == itm.uuid;
      });
      const mediaIndexByName = mediaWithOriginal.findIndex((itm) => {
        return mediaItem.name == itm.name;
      });
      if (mediaIndex !== -1) {
        mediaWithOriginal[mediaIndex]["isUserMade"] = true;
        const newItemIsDeleted = mediaItem?.is_deleted || 0;
        const mediaIndexLocal = mediaWithOriginal.findIndex((itm) => {
          return mediaItem.uuid == itm.uuid;
        });
        // times_used is 0 for a usage whose comment/line/category is deleted; only live usages add to the count
        if (newItemIsDeleted === 0 && mediaItem?.times_used !== 0 && mediaItem?.template_media && mediaIndexLocal !== -1) {
          if (mediaItem?.edited == false) {
            mediaWithOriginal[mediaIndexLocal].times_used = (mediaWithOriginal[mediaIndexLocal].times_used || 0) + 1;
          }
          mediaWithOriginal[mediaIndexLocal]["isUserMade"] = true;
          if (mediaWithOriginal[mediaIndexLocal].updated_at < mediaItem?.updated_at) {
            mediaWithOriginal[mediaIndexLocal].updated_at = mediaItem?.updated_at;
          }
        }
        // add only edited
        if (mediaItem?.edited && mediaDeletedFromRML !== 2 && mediaDeletedFromRML !== 3) {
          if (mediaIndexByName == -1) {
            mediaWithOriginal.push({
              ...mediaItem,
              id: uuidv4(),
              created_at: mediaItem?.updated_at,
              times_used: mediaItem?.is_deleted ? 0 : 1,
            });
          }
        }
      } else {
        const mediaDeletedFromRML = mediaItem?.is_deleted_from_rml || 0;
        if (mediaItem?.edited) {
          //store original as well
          if (mediaDeletedFromRML === 0 || mediaDeletedFromRML === 2) {
            let originalImage = {
              ...mediaItem,
              thumbnail: mediaItem.OriginThumbnail,
              newUrl: mediaItem?.OriginUrl,
              onlineUrl: mediaItem?.OriginUrl,
              id: uuidv4(),
              name: mediaItem?.OrginName || mediaItem?.orginName,
              edited: false,
              editCount: 0,
              times_used: 0,
              isUserMade: true,
            };
            const mediaIndexByNameLocal = mediaWithOriginal.findIndex((itm) => {
              // An original without a name (older edits lost it) would otherwise match every nameless item and be dropped.
              return originalImage.name ? originalImage.name === itm.name : originalImage.onlineUrl === itm.onlineUrl;
            });
            if (mediaIndexByNameLocal === -1) {
              mediaWithOriginal.push(originalImage);
            }
          }
          //push edited if 0 or 1, or if original slot is taken and this edit is unique
          if (mediaDeletedFromRML === 0 || mediaDeletedFromRML === 1) {
            const editedItem = { ...mediaItem, created_at: mediaItem?.updated_at, times_used: 1 };
            if (mediaIndexByName == -1) {
              mediaWithOriginal.push(editedItem);
            }
          }
        } else {
          if (mediaDeletedFromRML !== 1 && mediaDeletedFromRML !== 3) {
            if (mediaIndexByName === -1) {
              mediaWithOriginal.push(mediaItem);
            }
          }
        }
      }
    });

    uniqueMedia = mediaWithOriginal;
    setAllMediaList(uniqueMedia);
    let filteredMedia = uniqueMedia;
    if (filterValue == "Unused") {
      filteredMedia = uniqueMedia?.filter((data) => data?.times_used == 0);
    } else if (filterValue == "Used") {
      filteredMedia = uniqueMedia?.filter((data) => data?.times_used > 0 || data?.times_used == undefined);
    } else if (typeof filterValue === "number") {
      filteredMedia = uniqueMedia?.filter(data => data?.uploaded_by === filterValue);
    } else {
      filteredMedia = uniqueMedia;
    }
    const sortedMedia = filterValueFunction(filteredMedia, selected);
    setMediaList(sortedMedia);
  }, [storeData, filterValue, selected]);

  const parseDate = (dateString) => {
    if (!dateString?.includes("T")) {
      dateString = dateString?.replace(" ", "T") + ".000Z";
    }
    return new Date(dateString);
  };

  // Files from one batch often share the same created_at second, so ties fall back to updated_at and then upload order (later upload = newer).
  const sortByAge = (mediaItems, isNewestFirst) => {
    const uploadOrder = new Map(mediaItems?.map((media, index) => [media, index]));
    const direction = isNewestFirst ? -1 : 1;
    return mediaItems?.sort((a, b) => {
      const createdDiff = (parseDate(a.created_at ?? a.updated_at) - parseDate(b.created_at ?? b.updated_at)) || 0;
      if (createdDiff !== 0) return direction * createdDiff;
      // A decorated copy and its original share the decoration time, so the decorated copy goes first on Newest.
      const editedDiff = Number(Boolean(a.edited)) - Number(Boolean(b.edited));
      if (editedDiff !== 0) return direction * editedDiff;
      const updatedDiff = (parseDate(a.updated_at) - parseDate(b.updated_at)) || 0;
      if (updatedDiff !== 0) return direction * updatedDiff;
      return direction * (uploadOrder.get(a) - uploadOrder.get(b));
    });
  };

  const filterValueFunction = (result, filter) => {
    if (filter === "Newest") {
      return sortByAge(result, true);
    } else if (filter === "Oldest") {
      return sortByAge(result, false);
    } else if (filter === "Last used") {
      return result?.sort((a, b) => parseDate(b.updated_at) - parseDate(a.updated_at));
    } else if (filter === "File name") {
      return result?.sort((a, b) => a.name.localeCompare(b.name));
    } else if (filter === "Most used") {
      return result?.filter((data) => data?.is_deleted !== 1)?.sort((a, b) => b?.times_used - a?.times_used);
    } else {
      return result;
    }
  };

  const handleClose = async () => {
    setOpenDeleteMediaModal(false);
  };

  const handleDeleteRMLMedia = async () => {
    const updateTime = await GetUTCTime();
    let prevData = JSON.parse(JSON.stringify(storeData));
    const result = await DeleteRMLMedia(prevData, deleteMedia);
    //the same media uuid can appear in introductory_text_media across multiple categories,
    //so the delete API is called once per matching category rather than batched together
    const matchedIntroTextByCategory = [];
    prevData?.inspectionData?.data?.inspectiontemplates?.forEach((template) => {
      template?.categories?.forEach((category) => {
        const matchedMedia = category?.introductory_text_media
          ?.filter((media) => isSameRmlMedia(media, deleteMedia))
          ?.map((media) => {
            // The original and its decorated copy share a uuid, so only the copy actually being deleted is soft-deleted;
            // the other keeps is_deleted and just gains the half-deleted bit (1 = original, 2 = edited, 3 = both).
            return {
              ...media,
              is_deleted: isRecordDeleted(media, deleteMedia) ? 1 : media?.is_deleted ?? 0,
              is_deleted_from_rml: (Number(media?.is_deleted_from_rml) || 0) | (deleteMedia?.edited ? 2 : 1),
              updated_at: updateTime,
            };
        });
        if (matchedMedia?.length > 0) {
          matchedIntroTextByCategory.push({
            template_id: template?.template_id,
            category_id: category?.id,
            introductory_text_media: matchedMedia,
          });
        }
      });
    });

    if (matchedIntroTextByCategory?.length > 0){
      const payload = {
        inspection_id: storeData?.inspectionData?.data?.inspection_id,
        guid: storeData?.inspectionData?.data?.guid,
        inspectiontemplates: matchedIntroTextByCategory ?? [],
      };
      await apiCallDeleteIntroductoryTextMedia(dispatch, payload);
    }
    //intro text is only persisted by its own delete API, so mirror the flagged media onto the clone painted into the store
    matchedIntroTextByCategory.forEach(({ template_id, category_id, introductory_text_media }) => {
      const resultCategory = result?.inspectiontemplates?.find((template) => template?.template_id === template_id)?.categories?.find((category) => category?.id === category_id);
      if (!Array.isArray(resultCategory?.introductory_text_media)) return;
      //an edited copy shares its original's uuid, so without an id match on uuid + edited state
      resultCategory.introductory_text_media = resultCategory.introductory_text_media.map(
        (storedMedia) =>
          introductory_text_media.find((flaggedMedia) =>
            flaggedMedia?.id !== undefined ? flaggedMedia.id === storedMedia?.id : flaggedMedia?.uuid === storedMedia?.uuid && Boolean(flaggedMedia?.edited) === Boolean(storedMedia?.edited)
          ) ?? storedMedia
      );
    });

    const prunedPayload = {
      guid: result?.guid,
      inspectiontemplates: result?.prunedInspectiontemplates,
      report_media_library_files: result?.rmlFilesForDelete,
    };
    await UpdateTemplateDataSpecific(dispatch, result, prunedPayload);
    setOpenDeleteMediaModal(false);
  };

  const isUIDValidAndHasMedia = (uid, userDataList, mediaList) => {
    const userExists = userDataList?.some(user => user.user_id === uid);
    const hasMedia = mediaList?.some(media => media.uploaded_by === uid);
    return userExists && hasMedia;
  };

  return (
    <>
      {storeData?.isbulkUploading && warningModal && (
        <DeleteConfirmationDialog
          open={warningModal}
          handleClose={handleCloseWarningPopup}
          title={"Cancel bulk uploading"}
          contentText={`Are you sure you want to cancel uploading?`}
          cancelBtnTitle={"No"}
          cancelBtnAction={handleCloseWarningPopup}
          submitBtnTitle={"Yes"}
          submitBtnAction={handleCancelBulkUploadMedia}
        />
      )}
      <Dialog
        className="rml_popup"
        open={showRMLpopup}
        onClose={!storeData?.isbulkUploading ? handleCloseRMLpopup : handleBulkUploadingWarningPopup}
        aria-labelledby="category-modal"
        aria-describedby="category-modal-description"
      >
        <DialogTitle pb={0}>
          <Grid container display={"flex"}>
            <Grid item xs={11} display={"flex"} justifyContent={"flex-start"}>
              <Typography className="rml_popup_title">Report Library</Typography>
            </Grid>
            <Grid item xs={1} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
              {!storeData?.isbulkUploading ? (
                <div className="close-wrapper-new-category-right" style={{ marginTop: "10px" }}>
                  <CloseIcon onClick={handleCloseRMLpopup} />
                </div>
              ) : (
                <div className="close-wrapper-new-category-right" style={{ marginTop: "10px" }}>
                  <CloseIcon onClick={handleBulkUploadingWarningPopup} />
                </div>
              )}
            </Grid>
          </Grid>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ padding: "0px" }}>
          <Grid container>
            <Grid item xs={12} my={2}>
              <Box sx={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                <Box className="report_library__tab" sx={{ display: "flex", flexWrap: "wrap" }}>
                  <Tabs className="library_tab" value={activeTab} onChange={handleChange} aria-label="report_library_tab">
                    <Tab className="tab__label" label="All" {...a11yProps(0)} />
                    <Tab className="tab__label" label={"Images"} {...a11yProps(1)} sx={{ maxWidth: "61px" }} />
                    <Tab className="tab__label" label={"Videos"} {...a11yProps(1)} sx={{ maxWidth: "58px" }} />
                  </Tabs>
                  <div className="filter_container" style={{ height: "36px" }}>
                    <ThemeProvider theme={theme} className="maxwithclsss">
                      <Select
                        value={filterValue}
                        onChange={handleFilterChange}
                        className="rl-textfield"
                        MenuProps={{
                          MenuListProps: {
                            sx: {
                              px: "4px",
                              borderRadius: "4px",
                              border: "1px solid #E6E6E6",
                              minWidth: "150px",
                            },
                          },
                          PaperProps: { elevation: 0, sx: { mt: 1, gap: "8px" } },
                        }}
                        size="small"
                        // renderValue={(value) => {
                        //   if (typeof value === "number") {
                        //     const deduplicatedNames = new Set();
                        //     const availableUserIds = storeData?.inspectionDataForBulkMedia?.data?.report_media_library_files
                        //       ?.filter(e => e?.is_deleted !== 1 && e?.is_deleted_from_rml !== 1)
                        //       ?.filter(media => {
                        //         if (deduplicatedNames.has(media.name)) return false;
                        //         deduplicatedNames.add(media.name);
                        //         return true;
                        //       })
                        //       ?.map(media => media.uploaded_by);

                        //     if (!availableUserIds.includes(value)) {
                        //       setFilterValue("All");
                        //     }
                        //   }

                        //   const user = storeData?.userDataList?.find(u => u.user_id === value);
                        //   return (
                        //     <Typography noWrap sx={{ fontSize: "12px !important" }}>
                        //       {typeof value === "number" ? user?.full_name || "All" : value}
                        //     </Typography>
                        //   );
                        // }}
                        renderValue={(value) => {
                          if (typeof value === "number") {
                            const isValidUser = allMediaList?.some(media => media?.uploaded_by === value);

                            if (!isValidUser) {
                              setFilterValue("All");
                            }
                          }

                          const user = storeData?.userDataList?.find(u => u.user_id === value);
                          return (
                            <Typography noWrap sx={{ fontSize: "12px !important" }}>
                              {typeof value === "number" ? user?.full_name || "All" : value}
                            </Typography>
                          );
                        }}
                        //   // Fallback for 'All', 'Used', etc.
                        //   return (
                        //     <Typography noWrap sx={{ fontSize: "12px !important" }}>
                        //       {value}
                        //     </Typography>
                        //   );
                        // }}                      
                        startAdornment={<FilterListIcon className="rl-filter-icon" fontSize="small" sx={{ width: "13px", height: "13px", mr: "2px", color: "#737373 !important" }} />}
                      >
                        {sortFilters.map((option) => (
                          <MenuItem
                            value={option.value}
                            selected={filterValue === option.value}
                            sx={{
                              marginBottom: "5px",
                              borderRadius: "8px",
                              height: "32px",
                              "&.Mui-selected": {
                                backgroundColor: "#C7DBF6",
                                color: "white",
                                border: "1px solid #4282E2",
                                justifyContent: "space-between",
                              },
                              "&:hover": {
                                backgroundColor: "#e1ecfa",
                              },
                            }}
                          >
                            <Typography className={filterValue === option.value ? "report-filter-text-selected" : "report-filter-text-option"}>{option?.label}</Typography>
                            {filterValue === option.value && <CheckIcon sx={{ color: "#2F1073", height: "16px", width: "16px" }} />}
                          </MenuItem>
                        ))}
                        {storeData?.userDataList?.filter(user =>
                          allMediaList?.some(media => media.uploaded_by === user.user_id)
                        )?.length > 0 && <Divider />}
                        {storeData?.userDataList?.filter(user =>
                          allMediaList?.some(media => media.uploaded_by === user.user_id)
                        )?.map((option) => (
                          <MenuItem
                            value={option.user_id}
                            selected={filterValue === option.user_id}
                            sx={{
                              marginBottom: "5px",
                              borderRadius: "8px",
                              height: "32px",
                              "&.Mui-selected": {
                                backgroundColor: "#C7DBF6",
                                color: "white",
                                border: "1px solid #4282E2",
                                justifyContent: "space-between",
                              },
                              "&:hover": {
                                backgroundColor: "#e1ecfa",
                              },
                            }}
                          >
                            <Typography className={filterValue === option.user_id ? "report-filter-text-selected" : "report-filter-text-option"}>{option?.full_name}</Typography>
                            {filterValue === option.user_id && <CheckIcon sx={{ color: "#2F1073", height: "16px", width: "16px" }} />}
                          </MenuItem>
                        ))}
                      </Select>
                    </ThemeProvider>
                  </div>
                  <div className="filter_container" style={{ height: "36px" }}>
                    <ThemeProvider theme={theme}>
                      <Select
                        value={selected}
                        onChange={handleTimeFilterChange}
                        className="rl-textfield"
                        MenuProps={{
                          MenuListProps: {
                            sx: {
                              px: "4px",
                              borderRadius: "4px",
                              border: "1px solid #E6E6E6",
                              minWidth: "150px",
                            },
                          },
                          PaperProps: { elevation: 0, sx: { mt: 1, gap: "8px" } },
                        }}
                        size="small"
                        renderValue={(value) => (
                          <div style={{ overflow: "hidden", textOverflow: "ellipsis", width: "inherit" }}>
                            <Typography noWrap sx={{ color: "#737373 !important" }} className="filter_value">
                              {value}
                            </Typography>
                          </div>
                        )}
                        startAdornment={<SwapVertIcon className="rl-filter-icon" fontSize="small" sx={{ width: "13px", height: "13px", mr: "2px", color: "#737373 !important" }} />}
                      >
                        {filters.map((option) => (
                          <MenuItem
                            value={option.value}
                            selected={selected === option.value}
                            sx={{
                              marginBottom: "5px",
                              borderRadius: "8px",
                              height: "32px",
                              "&.Mui-selected": {
                                backgroundColor: "#C7DBF6",
                                color: "white",
                                border: "1px solid #4282E2",
                                justifyContent: "space-between",
                              },
                              "&:hover": {
                                backgroundColor: "#e1ecfa",
                              },
                            }}
                          >
                            <Typography className={selected === option.value ? "report-filter-text-selected" : "report-filter-text-option"}>{option?.label}</Typography>
                            {selected === option.value && <CheckIcon sx={{ color: "#2F1073", height: "16px", width: "16px" }} />}
                          </MenuItem>
                        ))}
                      </Select>
                    </ThemeProvider>
                  </div>
                </Box>
                <Box className="rml_popup_add_media_tab">
                  {!storeData?.isbulkUploading ? (
                    <Button
                      className="rml-popup-upload-button"
                      onClick={() => {
                        if (fileInput.current) {
                          fileInput.current.click();
                        }
                      }}
                      variant="outlined"
                      color="primary"
                      sx={{ textTransform: "none" }}
                      startIcon={<AddIcon />}
                    >
                      Upload
                      <input
                        ref={fileInput}
                        type="file"
                        accept="image/jpg,image/png,image/jpeg,video/mov,video/mp4,video/quicktime"
                        onChange={handleAddMedia}
                        style={{ display: "none" }}
                        multiple
                        component="label"
                      />
                    </Button>
                  ) : (
                    <Button className="disabled-rml-popup-upload-button" variant="outlined" color="primary" sx={{ textTransform: "none", backgroundColor: "#e5e5e5" }} startIcon={<AddIcon />} disabled>
                      Upload
                    </Button>
                  )}
                </Box>
              </Box>
              <TabPanel value={activeTab} index={0} className="tab_panel">
                <RMLPopupAllMedia
                  storeData={storeData}
                  handleCancelBulkUploadMedia={handleCancelBulkUploadMedia}
                  mediaList={mediaList}
                  handleErrorDoneButton={handleErrorDoneButton}
                  handleRetryFailMedia={handleRetryFailMedia}
                  failedMediaList={failedMediaList}
                  setHoveredDeletedMediaUuid={setHoveredDeletedMediaUuid}
                  hoveredDeletedMediaUuid={hoveredDeletedMediaUuid}
                  openDeleteMediaModal={openDeleteMediaModal}
                  setOpenDeleteMediaModal={setOpenDeleteMediaModal}
                  handleClose={handleClose}
                  setDeleteMedia={setDeleteMedia}
                  deleteMedia={deleteMedia}
                  handleDeleteRMLMedia={handleDeleteRMLMedia}
                  setSelectedMedia={setSelectedMedia}
                  selectedMedia={selectedMedia}
                  handleMediaClick={handleMediaClick}
                  isSelected={isSelected}
                />
              </TabPanel>
              <TabPanel value={activeTab} index={1} className="tab_panel">
                <RMLPopupImage
                  storeData={storeData}
                  mediaList={mediaList}
                  handleErrorDoneButton={handleErrorDoneButton}
                  handleCancelBulkUploadMedia={handleCancelBulkUploadMedia}
                  handleRetryFailMedia={handleRetryFailMedia}
                  failedMediaList={failedMediaList}
                  setHoveredDeletedMediaUuid={setHoveredDeletedMediaUuid}
                  hoveredDeletedMediaUuid={hoveredDeletedMediaUuid}
                  openDeleteMediaModal={openDeleteMediaModal}
                  setOpenDeleteMediaModal={setOpenDeleteMediaModal}
                  handleClose={handleClose}
                  setDeleteMedia={setDeleteMedia}
                  deleteMedia={deleteMedia}
                  handleDeleteRMLMedia={handleDeleteRMLMedia}
                  setSelectedMedia={setSelectedMedia}
                  selectedMedia={selectedMedia}
                  handleMediaClick={handleMediaClick}
                  isSelected={isSelected}
                />
              </TabPanel>
              <TabPanel value={activeTab} index={2} className="tab_panel">
                <RMLPopupVideo
                  storeData={storeData}
                  mediaList={mediaList}
                  handleErrorDoneButton={handleErrorDoneButton}
                  handleCancelBulkUploadMedia={handleCancelBulkUploadMedia}
                  handleRetryFailMedia={handleRetryFailMedia}
                  failedMediaList={failedMediaList}
                  setHoveredDeletedMediaUuid={setHoveredDeletedMediaUuid}
                  hoveredDeletedMediaUuid={hoveredDeletedMediaUuid}
                  openDeleteMediaModal={openDeleteMediaModal}
                  setOpenDeleteMediaModal={setOpenDeleteMediaModal}
                  handleClose={handleClose}
                  setDeleteMedia={setDeleteMedia}
                  deleteMedia={deleteMedia}
                  handleDeleteRMLMedia={handleDeleteRMLMedia}
                  setSelectedMedia={setSelectedMedia}
                  selectedMedia={selectedMedia}
                  handleMediaClick={handleMediaClick}
                  isSelected={isSelected}
                />
              </TabPanel>
            </Grid>
          </Grid>
        </DialogContent>
        <Divider />
        <DialogActions className="non-narrative-dialog-actions">
          {!storeData?.isbulkUploading ? (
            <>
              <Button variant="outlined" className="rml-popup-cancel-button" onClick={handleCloseRMLpopup}>
                Cancel
              </Button>
              <Button
                variant="contained"
                className={selectedMedia?.length > 0 ? "rml-popup-save-button" : "rml-popup-save-button-disable"}
                onClick={selectedMedia?.length > 0 ? handleUploadIntroTextMedia : undefined}
              >
                Add {selectedMedia?.length || 0} media
              </Button>{" "}
            </>
          ) : (
            <>
              <Button variant="outlined" className="rml-popup-cancel-button-disable" onClick={handleBulkUploadingWarningPopup}>
                Cancel
              </Button>
              <Button variant="contained" className="rml-popup-save-button-disable">
                Add {selectedMedia?.length} media
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RMLpopup;